<template>
  <div>
    <PageTitleWithSearch :title="'Service Projects'" :loading="loading" :search="search"
      @searchText="searchChange($event)"></PageTitleWithSearch>
    <v-card v-if="!loading && projects">
      <v-card-title dark>
        <v-spacer></v-spacer>
        <v-btn v-if="checkRole()" small depressed class="white--text" color="blue" title="Add" :to="'/projects/create'">
          Create New Project
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" width="15%">
                  Project Code
                </th>
                <th class="text-left" width="22%">
                  Project Title
                </th>
                <th class="text-center" width="10%">
                  Club
                </th>
                <th class="text-center " width="12%">
                  Status
                </th>
                <th class="text-center" width="5%">
                  Type
                </th>
                <th class="text-center" width="12%">
                  Date
                </th>
                <th width="5%" class="text-center" colspan="3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in projects" :key="item.uuid">
                <td>{{ item.project_code }}</td>
                <td>{{ item.project_title }}</td>
                <td v-if="item.club" class="text-center">
                  {{ item.club.name }}
                </td>
                <td class="text-center">
                  <v-chip x-small class="ma-2" dark :color="getStatusColor(item.status)">
                    {{ stringFormatting(item.status) }}
                  </v-chip>
                </td>
                <td class="text-center">{{ item.project_type }}</td>
                <td class="text-center">{{ item.created_at }}</td>

                <td class="text-center">
                  <v-btn title="view" x-small dark color="green" :to="'/projects/info/' + item.uuid" fab>
                    <v-icon dark small>
                      mdi-eye
                    </v-icon></v-btn>
                </td>
                <td class="text-center">
                  <v-btn v-if="canEdit(item.status, item.project_type)" color="orange"
                    :to="'/projects/edit/1/' + item.uuid" fab x-small dark title="Edit">
                    <v-icon small> mdi-pencil </v-icon>
                  </v-btn>
                </td>
                <!-- <td class="text-center">
                  <v-btn v-if="canPending(item.status)" color="blue" fab x-small dark title="Pending"
                    @click="changeStatusPending(item.uuid)">
                    <v-icon small> mdi-update </v-icon>
                  </v-btn>
                </td> -->
                <td class="text-center">
                  <v-btn v-if="canDelete(item.status)" color="red" fab x-small dark title="Delete"
                    @click="deleteProject(item.uuid)">
                    <v-icon small> mdi-delete </v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>
    <v-card class="pl-5 pr-5">
      <Pagination @previous="page--" @next="page++" :loading="loading" :total="total" :page="Number(page)"></Pagination>
    </v-card>
    <ConfirmModal :text="'Do you want to delete this project?'" :title="'Delete Project'" :color="'red'"
      :confirmOpen="confirmOpen" @cancelConfirm="cancelConfirm()" @confirm="confirm()"></ConfirmModal>
    <ConfirmModalWithComment :title="'Pending Project'" :color="'blue'" :confirmCommentOpen="confirmCommentOpen"
      @cancelCommentConfirm="cancelCommentConfirm()" @confirmComment="confirmComment($event)"></ConfirmModalWithComment>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { ProjectService } from "../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
import Pagination from "@/components/shared/Pagination";
import ConfirmModal from "@/components/shared/ConfirmModal";
import ConfirmModalWithComment from "@/components/shared/ConfirmModalWithComment";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";

export default {
  name: "ProjectGrid",
  components: {
    Pagination,
    ConfirmModal,
    ConfirmModalWithComment,
    PageTitleWithSearch,
  },
  data: function () {
    return {
      projects: [],
      page: 1,
      search: "",
      loading: false,
      totalProjects: 0,
      total: 0,
      deleteUuid: null,
      pendingUuid: null,
      confirmOpen: false,
      confirmCommentOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      role: "getRole",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getProjects();
  },

  watch: {
    search() {
      this.page = 1;
      localStorage.setItem("project_page", 1);
      this.getProjects();
    },
    page(val) {
      localStorage.setItem("project_page", val);
      this.getProjects();
    },
  },

  methods: {
    getProjects() {
      this.page = localStorage.getItem('project_page') || 1;
      this.loading = true;
      ProjectService.getProjectList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProjects = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          this.total = 0;
          this.totalProjects = 0;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "SUBMITTED":
          bgColor = "blue";
          break;

        case status === "PROJECT_CHAIRMAN_REVIEW":
          bgColor = "purple";
          break;

        case status === "CLUB_PRESIDENT_SECRETARY_REVIEW":
          bgColor = "blue-grey lighten-1";
          break;

        case status === "ZONE_CHAIRPERSON_REVIEW":
          bgColor = "amber accent-2";
          break;

        case status === "REGION_CPE_CHAIRPERSON_REVIEW":
          bgColor = "brown lighten-1";
          break;

        case status === "REGION_GST_REVIEW":
          bgColor = "deep-purple accent-1";
          break;

        case status === "PENDING":
          bgColor = "red";
          break;

        case status === "PROCESSING":
          bgColor = "grey darken-1";
          break;

        case status === "APPROVED":
          bgColor = "green";
          break;
        default:
          bgColor = "orange";
          break;
      }
      return bgColor;
    },

    searchChange(value) {
      this.search = value;
    },

    checkRole() {
      if (
        this.role === "CLUB_PRESIDENT" ||
        this.role === "CLUB_SECRETARY" ||
        this.role === "CLUB_TREASURER" ||
        this.role === "CLUB_ADMINISTRATOR" ||
        this.role === "REGION_CHAIRPERSON" ||
        this.role === "CLUBS_PERFORMANCE_EVALUATION" ||
        this.role === "REGION_GST_COORDINATOR" ||
        this.role === "CLUB_GST_COORDINATOR"
      ) {
        return true;
      } else {
        return false;
      }
    },

    canEdit(status, type) {
      if (status == "PENDING" || status == "PROCESSING") {
        if (
          (type === "RP" || type === "JRP") &&
          (this.role === "REGION_CHAIRPERSON" ||
            this.role === "REGION_GST_COORDINATOR" ||
            this.role === "CLUBS_PERFORMANCE_EVALUATION")
        ) {
          return true;
        } else if (
          this.role === "CLUB_PRESIDENT" ||
          this.role === "CLUB_SECRETARY" ||
          this.role === "CLUB_TREASURER" ||
          this.role === "CLUB_ADMINISTRATOR" ||
          this.role === "CLUB_GST_COORDINATOR" ||
          this.role === "CLUBS_PERFORMANCE_EVALUATION"
        ) {
          return true;
        }
      }
      return false;
    },

    canPending(status) {
      if (
        status !== "PENDING" &&
        status !== "PROCESSING" &&
        status !== "APPROVED" &&
        this.role === "CLUBS_PERFORMANCE_EVALUATION"
      ) {
        return true;
      }
      return false;
    },

    canDelete(status) {
      if (
        status !== "APPROVED" &&
        this.role === "CLUBS_PERFORMANCE_EVALUATION"
      ) {
        return true;
      }
      return false;
    },

    deleteProject(uuid) {
      this.deleteUuid = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.loading = true;
      ProjectService.delete(this.deleteUuid)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.getProjects();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    cancelCommentConfirm() {
      this.confirmCommentOpen = false;
    },

    changeStatusPending(uuid) {
      this.pendingUuid = uuid;
      this.confirmCommentOpen = true;
    },

    confirmComment(value) {
      this.confirmCommentOpen = false;
      this.loading = true;
      let data = { pending_comment: value };
      ProjectService.statusPending(this.pendingUuid, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.getProjects();
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
